/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MathDeltaIcon64Regular = forwardRef('MathDeltaIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m37.687 9.273 19.972 36.079C60.057 49.684 56.924 55 51.972 55H12.028c-4.952 0-8.085-5.316-5.687-9.648L26.313 9.273c2.474-4.47 8.9-4.47 11.374 0Zm-3.805 3.437 18.88 34.108c1.292 2.333-.395 5.196-3.061 5.196H11.938c-2.666 0-4.353-2.863-3.062-5.196L27.757 12.71c1.332-2.406 4.792-2.406 6.125 0Z" })));
});
